module.exports = __webpack_public_path__ + "static/acupun_2-15c551dad4c53b37db69ea474af98571.webp";